var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartyHai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E87B5A"
    },
    points: "429.64,313.424 476.384,354.976 466,292.648 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC97B"
    },
    d: "M104,416h240V312H104V416z M187.136,337.552c6.856-6.856,17.712-7.936,25.784-2.56l11.08,7.392 L235.08,335c8.08-5.368,18.92-4.312,25.792,2.552c7.96,7.968,7.96,20.936,0,28.904l-31.208,31.208 C228.096,399.216,226.048,400,224,400s-4.096-0.784-5.656-2.344l-31.208-31.208C179.168,358.48,179.168,345.52,187.136,337.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E87B5A"
    },
    d: "M224,380.688l25.552-25.552c1.728-1.728,1.728-4.544,0-6.272c-1.488-1.48-3.848-1.712-5.608-0.552 l-15.504,10.344c-2.688,1.792-6.184,1.792-8.872,0l-15.512-10.344c-0.752-0.496-1.6-0.736-2.456-0.736 c-1.152,0-2.296,0.44-3.152,1.296c-1.728,1.728-1.728,4.536,0,6.272L224,380.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M291.856,164.984L320,179.056v-43.448C312.96,146.384,303.528,156.16,291.856,164.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M368.6,137.864l33-44c-21.272-0.832-42.152-1.88-62.496-3.184L368.6,137.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M259.152,131.408l54.632-42.496c-26.672-2-52.328-4.416-76.72-7.224L259.152,131.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M456.6,137.864l31.472-41.968c-19.712-0.16-39.176-0.536-58.384-1.08L456.6,137.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M68.096,104.592L111.6,61.088C87.496,55.52,67.32,49.496,51.296,43.024L68.096,104.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M139.672,67.056l16.392,54.632l49.44-43.952c-17.224-2.336-33.768-4.864-49.36-7.624 C150.472,69.12,145.024,68.096,139.672,67.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M149.104,258.832l21.248-47.824c-20.152,3.704-42.136,6.616-65.928,8.736L149.104,258.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M55.2,270.096l21.448-48.264c-15.08,0.904-30.864,1.504-47.24,1.84L55.2,270.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC7D1"
    },
    d: "M244.432,228.336l20.872-46.96c-17.12,8.696-37.28,16.096-60.584,22.136L244.432,228.336z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4A53"
    },
    d: "M226.208,64.432c-0.192-0.056-0.328-0.208-0.528-0.248c-0.424-0.096-0.848,0.048-1.28,0.032 c-35.048-4.384-65.888-9.448-92.16-14.936c-0.704-0.448-1.464-0.824-2.296-1.032c-0.984-0.256-1.984-0.248-2.96-0.12 C56.808,32.976,20,14.96,20,0H4c0,11.92,8.968,22.944,26.528,33.056l-29.68,59.36l14.312,7.16l22.632-45.272l18.496,67.8 c0.752,2.752,2.904,4.896,5.664,5.624c2.76,0.744,5.704-0.056,7.712-2.072l54.528-54.528l20.152,67.168 c0.792,2.616,2.848,4.656,5.48,5.4c2.64,0.76,5.456,0.096,7.496-1.712l63.824-56.728l27.552,62c1,2.248,2.976,3.912,5.368,4.504 c2.376,0.6,4.912,0.064,6.864-1.44l54.704-42.552c-13.256,40.104-56.992,68.272-130.776,84.32 c-1.064-0.112-2.144-0.056-3.184,0.264c-0.456,0.144-0.808,0.472-1.232,0.688C132.504,202.992,72.336,208,0,208v16 c3.808,0,7.504-0.048,11.248-0.08l37.76,67.968C50.424,294.432,53.104,296,56,296c0.12,0,0.232,0,0.352,0 c3.032,0,5.728-1.976,6.96-4.744l27.584-62.088l55.832,48.848c1.904,1.672,4.488,2.336,6.984,1.792 c2.488-0.544,4.56-2.24,5.592-4.56l28.256-63.584l56.184,35.12c1.976,1.224,4.384,1.544,6.584,0.864 c2.208-0.68,4.024-2.28,4.968-4.4l28.6-64.352l40.504,20.256c2.488,1.232,5.424,1.112,7.784-0.352 c2.376-1.448,3.816-4.024,3.816-6.8v-76.104l25.216,40.344c1.4,2.24,3.808,3.648,6.448,3.752c2.624,0.088,5.152-1.08,6.736-3.192 l41-54.664l33.824,54.112c1.4,2.24,3.808,3.76,6.448,3.76c0.112,0,0.224,0,0.336,0c2.504,0,4.88-1.176,6.4-3.2l45.616-60.816 C509.344,95.984,510.664,96,512,96V80C397.76,80,302.048,73.832,226.208,64.432z M68.096,104.592l-16.8-61.568 c16.024,6.472,36.192,12.496,60.296,18.064L68.096,104.592z M156.064,121.688l-16.392-54.632c5.352,1.04,10.808,2.056,16.472,3.056 c15.6,2.752,32.136,5.28,49.36,7.624L156.064,121.688z M259.152,131.408l-22.088-49.712c24.392,2.808,50.048,5.224,76.72,7.224 L259.152,131.408z M55.2,270.096l-25.792-46.424c16.384-0.336,32.16-0.936,47.24-1.84L55.2,270.096z M149.104,258.832 l-44.68-39.088c23.8-2.12,45.776-5.032,65.928-8.736L149.104,258.832z M244.432,228.336l-39.712-24.824 c23.304-6.04,43.464-13.44,60.584-22.136L244.432,228.336z M320,179.056l-28.144-14.072c11.672-8.824,21.104-18.592,28.144-29.376 V179.056z M368.6,137.864L339.104,90.68c20.344,1.296,41.224,2.352,62.496,3.184L368.6,137.864z M456.6,137.864l-26.912-43.056 c19.208,0.552,38.672,0.92,58.384,1.08L456.6,137.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4A53"
    },
    d: "M352,296H96c-4.424,0-8,3.584-8,8v120v88h16v-80h240v80h16v-88V304C360,299.584,356.424,296,352,296 z M344,416H104V312h240V416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4A53"
    },
    d: "M218.344,397.656c1.56,1.56,3.608,2.344,5.656,2.344s4.096-0.784,5.656-2.344l31.208-31.208 c7.96-7.968,7.96-20.928,0-28.904c-6.864-6.864-17.712-7.92-25.792-2.552L224,342.384l-11.088-7.392 c-8.072-5.376-18.92-4.296-25.784,2.56c-7.96,7.968-7.96,20.928,0,28.896L218.344,397.656z M198.448,348.864 c0.848-0.856,2-1.296,3.152-1.296c0.848,0,1.704,0.24,2.456,0.736l15.512,10.344c2.688,1.792,6.192,1.792,8.872,0l15.504-10.344 c1.76-1.16,4.128-0.928,5.608,0.552c1.728,1.728,1.728,4.544,0,6.272L224,380.688l-25.552-25.552 C196.72,353.408,196.72,350.592,198.448,348.864z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C4A53"
    },
    points: "220.688,46.624 232,35.312 243.312,46.624 254.624,35.312 243.312,24 254.624,12.688  243.312,1.376 232,12.688 220.688,1.376 209.376,12.688 220.688,24 209.376,35.312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C4A53"
    },
    points: "51.312,409.376 40,420.688 28.688,409.376 17.376,420.688 28.688,432 17.376,443.312  28.688,454.624 40,443.312 51.312,454.624 62.624,443.312 51.312,432 62.624,420.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C4A53"
    },
    points: "299.312,449.376 288,460.688 276.688,449.376 265.376,460.688 276.688,472 265.376,483.312  276.688,494.624 288,483.312 299.312,494.624 310.624,483.312 299.312,472 310.624,460.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C4A53"
    },
    points: "436.688,46.624 448,35.312 459.312,46.624 470.624,35.312 459.312,24 470.624,12.688  459.312,1.376 448,12.688 436.688,1.376 425.376,12.688 436.688,24 425.376,35.312  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 136,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 176,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 24,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 320,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 440,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 480,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 344,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 192,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 224,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 40,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4A53"
    },
    d: "M460.6,427.432c2.968-2.16,6.528-3.832,10.304-5.608c3.32-1.56,6.752-3.176,10.112-5.264 c16.128-10.048,16.416-24.352,13.696-36.36c1.008-1.616,1.504-3.544,1.176-5.512l-16-96c-0.432-2.584-2.096-4.792-4.464-5.912 c-2.36-1.128-5.128-1.024-7.4,0.28l-56,32c-2.232,1.28-3.72,3.552-3.984,6.12c-0.272,2.56,0.712,5.096,2.64,6.808l66.504,59.112 c4.264,13.408,4.216,20.36-4.632,25.872c-2.56,1.6-5.44,2.944-8.48,4.376c-4.272,2.016-8.704,4.096-12.896,7.144 c-8.68,6.328-15.624,17.872-11.568,29.448c2.408,6.832,8.408,12.32,16.912,15.464c2.832,1.048,5.776,1.8,8.712,2.536 c2.44,0.608,4.88,1.208,7.232,2.088c0.624,0.232,1.16,0.504,1.576,0.76c-0.112,0.096-0.216,0.2-0.336,0.312 c-10.312,9.552-21.76,17.904-34.008,24.824l7.872,13.928c13.328-7.528,25.784-16.616,37-27c1.832-1.704,5.264-4.864,6.16-9.864 c1.32-7.392-3.768-14.608-12.64-17.936c-2.912-1.096-5.936-1.872-8.968-2.632c-2.384-0.6-4.768-1.176-7.064-2.024 c-3.832-1.416-6.584-3.568-7.36-5.76C453.496,435.184,456.76,430.224,460.6,427.432z M429.64,313.424L466,292.648l10.384,62.328 L429.64,313.424z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.628,
    y: 229.002,
    transform: "matrix(-0.1961 0.9806 -0.9806 -0.1961 781.4387 -166.6348)",
    style: {
      fill: "#3C4A53"
    },
    width: 40.793,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.989,
    y: 220.678,
    transform: "matrix(-0.8574 0.5146 -0.5146 -0.8574 890.8046 241.1993)",
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 46.647
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.992,
    y: 255.578,
    transform: "matrix(-0.1961 0.9806 -0.9806 -0.1961 725.1235 -42.5214)",
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 40.793
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 448,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 448,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 448,
    style: {
      fill: "#3C4A53"
    },
    width: 16,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyHai);
export default __webpack_public_path__ + "static/media/party_hai.059e6c62b0c54b96d7b5497b5c7a9174.svg";
export { ForwardRef as ReactComponent };